// extracted by mini-css-extract-plugin
export const tabs = "SectionTabs-module--tabs--2yhRX";
export const tabList = "SectionTabs-module--tab-list--3UpaC";
export const tab = "SectionTabs-module--tab--2B6aW";
export const tabVariantRegular = "SectionTabs-module--tab-variant-regular--bPuy5";
export const tabVariantCompact = "SectionTabs-module--tab-variant-compact--2pOvf";
export const tabPanel = "SectionTabs-module--tab-panel--NarQT";
export const tabPanelSelected = "SectionTabs-module--tab-panel-selected--36VAX";
export const spacingTopRegular = "SectionTabs-module--spacing-top-regular--q_Ywl";
export const spacingBottomRegular = "SectionTabs-module--spacing-bottom-regular--1jjLe";
export const spacingTopCompact = "SectionTabs-module--spacing-top-compact--1twuJ";
export const spacingBottomCompact = "SectionTabs-module--spacing-bottom-compact--u_3pk";